<template>
  <div>
    <v-container grid-list-l class="word-wrap">
      <v-layout row wrap mt-5 justify-center>
        <div
          class="menu-grid"
        >
          <card-menu v-for="(item, i) in items" :key="i" :item="item" />
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import CardMenu from '../../components/Menu/CardMenu.vue';
export default {
  data: () => {
    return {
      items: [
        {
          color: '#0051A4',
          icon: 'newComers.svg',
          title: 'Yeni Katılanlar',
          to: '/newComers',
          isAdmin: false,
        },
        {
          color: '#FF9400',
          icon: 'bornToday.svg',
          title: 'Bugün Doğanlar',
          to: '/bornTodayUsers',
          isAdmin: false,
        },
        {
          color: '#009800',
          icon: 'whoIsWho.svg',
          title: 'Kim Kimdir?',
          to: '/whosWho',
          isAdmin: false,
        },
        {
          color: '#3F0089',
          icon: 'most.svg',
          title: "BSP'nin Enleri",
          to: '/bestOfUsers',
          isAdmin: false,
        },
        {
          color: '#B1007C',
          icon: 'community.svg',
          title: 'Topluluk Uygulamaları',
          to: '/otherApplication',
          isAdmin: false,
        },
        {
          color: '#FFD100',
          icon: 'thanks.svg',
          title: 'Teşekkür Et',
          to: '/thanksForm',
          isAdmin: false,
        },
        {
          color: '#0E2B63',
          icon: 'archive.svg',
          title: 'Canlı Yayın Arşivi',
          to: '/liveStreamArchive',
          isAdmin: false,
        },
        {
          color: '#01B1EB',
          icon: 'request.svg',
          title: 'Canlı Yayın İstekleri',
          to: '/liveStreamRequest',
          isAdmin: true,
        },
        {
          color: '#E72582',
          icon: 'survey.svg',
          title: 'Anketler',
          to: '/surveyList',
          isAdmin: false,
        },
        {
          color: '#50AF47',
          icon: 'adverts.svg',
          title: 'İlanlar',
          to: '/adverts',
          isAdmin: false,
        },
      ],
    };
  },
  components: {
    CardMenu,
  },
  methods: {},
  computed: {},
  destroyed() {},
  mounted() {},
  watch: {},
};
</script>

<style>
.gradientBg {
  background: rgb(162, 155, 254);
  background: linear-gradient(
    00deg,
    rgba(162, 155, 254, 1) 0%,
    rgba(255, 118, 117, 1) 100%
  );
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
}

@media (min-width: 600px) {
  .menu-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .menu-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
